import React from "react";

const RequiredIcon = ({
  height = 5,
  width = 6,
  color = "none",
  className = "",
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 6 5"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.792 4.488L2.652 2.7L3.216 2.292L4.548 3.948L3.792 4.488ZM2.028 4.512L1.284 3.972L2.628 2.328L3.18 2.736L2.028 4.512ZM2.784 2.844L0.732 2.304L1.032 1.416L3 2.196L2.784 2.844ZM2.556 2.532L2.436 0.408H3.36L3.24 2.532H2.556ZM3 2.856L2.796 2.196L4.776 1.44L5.052 2.316L3 2.856Z"
      fill="#FF4F4F"
    />
  </svg>
);

export default RequiredIcon;
